<template>
    <div class="select-lps">
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">{{ $t('selecionar-lps') }}</h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    :class="countInativos > 0 ? 'mr-3' : ''"
                    type="button"
                    @click="closeModal()"
                >
                    {{ $t('cancelar') }}
                </button>

                <button
                    v-if="countInativos > 0"
                    class="save-btn"
                    type="button"
                    @click="done()"
                    :disabled="countInativos > 0"
                    v-tippy 
                    :title="$t('msg-rotas-inativas')"
                >
                    {{ $t('confirmar') }}
                </button>
                
                <button
                    v-else
                    class="save-btn"
                    type="button"
                    @click="done()"
                    :disabled="countInativos > 0"
                >
                    {{ $t('confirmar') }}
                </button>
            </div>
        </div>
        <div class="list">
            <SearchList
                :value="items"
                label="codigo"
                :onSearch="debouncedOnSearch"
                :onCheck="selecionarLPS"
                :placeholder="$t('pesquisar-codigo-lps')"
                checkable
                :loading="loading"
                :aditionalFields="['descricao', 'rsocial', 'endereco']"
            />

            <!--
                @70188 - Caso não tenha nenhum contrato com LPS inserida
                informa ao usuário.
            -->
        </div>
    </div>
</template>

<script>
import SearchList from '@/components/shared/SearchList';
import ProLpsService from '@/services/promotor/ProLpsService';

export default {
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        value: {
            default: 0,
        },
    },
    components: {
        SearchList,
    },
    data() {
        return {
            items: [],
            dias: [],
            service: null,
            main: this.$parent.$parent,
            mirror: '',
            loading: false,
            countInativos: 0,
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.filtrarLPS, 500);
        let list = [];

        for (let i of this.list[this.value].lpss) {
            list.push(i.id);
        }

        this.service = new ProLpsService(this.$http, this.$router);
        this.dias = [...this.list];
        this.mirror = JSON.stringify(this.dias);
        this.$parent.onclose = () => {
            let dias = JSON.parse(this.mirror);
            this.main.$emit('update-lps', dias);
        };
        this.loading = true;
        this.service
            .findAllWithContracts(0, 50, list, '')
            .then(this.mapItems)
            .catch((e) => {
                console.error('Erro ao carregar LPS! ', e);
                this.msgs.push(new Message('error', 'msg-erro-carregar-lps', true));
                this.loading = false;
            })
            .then((items) => {
                this.items = items;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
        filtrarLPS(filtro) {
            let list = [];

            for (let i of this.list[this.value].lpss) {
                list.push(i.id);
            }
            return this.service
                .findAllWithContracts(0, 30, list, filtro)
                .then(this.mapItems)
                .catch((e) => {
                    console.error('Erro ao carregar LPS! ', e);
                    this.msgs.push(new Message('error', 'msg-erro-carregar-lps', true));
                })
                .then((items) => {
                    this.items = items;
                });
        },
        done() {
            this.closeModal(() => {
                this.main.$emit('update-lps', this.dias);
            });
        },
        mapItems(body) {
            let lpss = body.content.map((i) => {
                if (i.replicapda != 3) {
                    i.situacao = 0;
                }
                if (i.situacao != 1) {
                    this.countInativos++;
                }

                const estadoDescricao = i.cidade && i.cidade.estado ? i.cidade.estado.descricao : ''
                const cidadeDescricao = i.cidade ? i.cidade.descricao : '';

                return {
                    id: i,
                    codigo: i.idlpserp,
                    descricao: i.nome,
                    situacao: i.situacao, //@84447 - Passa a situação para o SearchList
                    check: this.isChecked(i.idlps),
                    rsocial: i.rsocial,
                    endereco: 
                        `${estadoDescricao} - 
                         ${cidadeDescricao}
                         ${i.endereco ? ', ' + i.endereco + (i.numero ? ', ' + i.numero : '') : ''}`,
                };
            });
            return lpss;
        },
        closeModal(onclose) {
            this.$parent.closeModal(onclose);
        },
        isChecked(idlps) {
            let dia = this.dias[this.value];
            if (dia) {
                return dia.lpss.filter((lps) => lps.idlps == idlps).length > 0;
            }
            return false;
        },
        selecionarLPS(val, index) {
            let dia = this.dias[this.value];
            let lpsw = dia.lpss.filter((l) => {
                return val.id.idlps == l.id;
            })[0];
            if (val.check) {
                if (lpsw) {
                    this.dias[this.value].lpss.splice(
                        this.dias[this.value].lpss.indexOf(lpsw),
                        1,
                        val.id
                    );
                } else {
                    this.dias[this.value].lpss.push(val.id);
                }
                if (val.situacao == 0) {
                    this.countInativos++;
                }
            } else {
                this.dias[this.value].lpss.splice(this.dias[this.value].lpss.indexOf(lpsw), 1);
                if (val.situacao == 0) {
                    this.countInativos--;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.select-lps {
    .list {
        flex: 1 1 auto;
        height: calc(100% - 100px);
        border: 1px solid $table-border;
        box-shadow: none;
    }
}

.form-buttons {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
}

.form-buttons .save-btn,
.form-buttons .delete-btn {
    color: $sovis-white;
    font-size: 12px;
    text-align: center;
    padding: 15px 40px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    margin-left: 20px;
    @include gradient-button();
}

.form-buttons .delete-btn {
    right: 225px;
    color: $darker-gray-color;
    @include exclude-button();
}

.list {
    margin-top: 30px;
}

.box-centralizar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .icone-svg-lps {
        @include gradient-circle();
        width: 200px;
        height: 200px;
        border-radius: 50%;
        position: relative;

        svg {
            position: absolute;
            top: 17%;
            left: 23%;
        }
    }

    .mensagem-usuario {
        text-align: center;
        width: 70%;
        margin-top: 5px;
    }

    @media (max-width: 500px) {
        .icone-svg-lps {
            display: none;
        }
    }
}
</style>
